var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"phone-wrapper"},[_c('Phone')],1),_c('div',[_c('RouterLink',{staticClass:"btn",attrs:{"to":{name: 'contact'}}},[_vm._v("Contact us")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }